<template>
  <div id="add_transfer__modal">
    <!-- Add Transfer popup -->
    <vs-popup id="add_transfer__popup" class="vs-con-loading__container text-center" title="Add Transfer" button-accept="false" button-cancel="false" :active.sync="isActive">
      <form method="post" @submit.prevent="addTransfer">
        <div class="vx-row mt-3">
          <div class="vx-col w-full">
            <div class="vx-col md:w-2/4 px-8">
              <!-- Supplier -->
              <div class="vx-row mb-2">
                <label for="supplier_id">Supplier <span class="text-danger">*</span></label>
                <select-2
                  class="w-full"
                  ref="supplierList"
                  :value="form.supplierId"
                  @input="
                    (item) => {
                      this.form.supplierId = item && item.value
                      this.form.supplier_type = item && (item.type === 'user' ? 'user' : 'supplier')
                    }
                  "
                  name="Supplier Name"
                  v-validate="'required'"
                  placeholder="Select Supplier Name"
                  autocomplete
                  newLabel="Add New Supplier"
                  @addNew="
                    () => {
                      isActive = false
                      isAddSupplierModalShow = true
                    }
                  "
                  :extra="[{ label: 'My Business', value: user.id, type: 'user' }]"
                  action="supplier/getSupplierOption"
                />
                <span class="mt-3 text-danger text-sm" v-show="errors.has('Supplier Name')">{{ errors.first('Supplier Name') }}</span>
              </div>

              <!-- Transporter -->
              <div class="vx-row mb-2">
                <label for="transporter_id">Transporter </label>
                <select-2
                  class="w-full"
                  ref="transporterList"
                  :value="form.transporterId"
                  @input="
                    (item) => {
                      this.form.transporterId = item && item.value
                    }
                  "
                  name="Transporter Name"
                  placeholder="Select Transporter Name"
                  autocomplete
                  newLabel="Add New Transporter"
                  @addNew="
                    () => {
                      isActive = false
                      isAddTransporterModalShow = true
                    }
                  "
                  label="business_name"
                  action="transporter/getTransporters"
                />
                <span class="mt-3 text-danger text-sm" v-show="errors.has('Transporter Name')">{{ errors.first('Transporter Name') }}</span>
              </div>
            </div>

            <!-- form action -->
            <div class="float-center mt-5">
              <vs-button button="submit" class="mr-2 vs-con-loading__container" id="add-product-button" type="relief">Save</vs-button>
              <vs-button color="danger" type="relief" class="text-left" @click="isActive = false">Cancel</vs-button>
            </div>
          </div>
        </div>
      </form>
    </vs-popup>

    <!-- add transporter modal -->
    <add-transporter-modal :showModal.sync="isAddTransporterModalShow" @updateList="updateTransporterList" :toggleModal="toggleModal" />

    <!-- add supplier modal -->
    <add-supplier-modal :showModal.sync="isAddSupplierModalShow" @updateList="updateSupplierList" :toggleModal="toggleModal" />
  </div>
</template>

<script>
import Select2 from '@/components/custom/form-elements/Select2.vue'
import AddTransporterModal from '@/views/transporters/AddTransporter'
import AddSupplierModal from '@/views/suppliers/AddSupplier'
import { mapState } from 'vuex'

export default {
  name: 'AddItemProduct',

  components: {
    Select2,
    AddSupplierModal,
    AddTransporterModal
  },

  props: {
    showModal: Boolean
  },

  data() {
    return {
      supplierOptions: [],
      isAddTransporterModalShow: false,
      isAddSupplierModalShow: false,
      form: {
        transferType: 'incoming',
        supplierId: null,
        transporterId: null,
        supplier_type: null
      }
    }
  },

  computed: {
    ...mapState('auth', ['user']),

    validateForm() {
      return !this.errors.any()
    },

    // close the poup
    isActive: {
      get() {
        return this.showModal
      },
      set(val) {
        this.$emit('update:showModal', val)
      }
    }
  },

  methods: {
    async addTransfer() {
      if (!(await this.$validator.validate())) {
        return false
      }

      this.$emit('update:showModal', false)

      this.$router.push({ name: 'transfer-details', query: { ...this.form } })
    },

    updateSupplierList(data) {
      this.isActive = true
      this.$refs.supplierList.getOptions()

      this.$nextTick(() => {
        this.form.supplierId = data.id
      })
    },

    updateTransporterList(data) {
      this.isActive = true
      this.$refs.transporterList.getOptions()

      this.$nextTick(() => {
        this.form.transporterId = data.id
      })
    },

    toggleModal() {
      this.isActive = true
    }
  }
}
</script>

<style lang="scss"></style>
